import React from 'react';
import { useSelector } from 'react-redux';

import {
  StyledErrorContainer,
  StyledErrorMessage,
  StyledErrorHelperMessage
} from 'bento-ordering/group_ordering/ui_components/GroupOrder';

import { selectGroupOrderError } from 'bento-ordering/cart/selectors/index';

const GroupOrderErrorToast = () => {
  const error = useSelector(selectGroupOrderError);

  if (!error || !Object.keys(error).length) {
    return null;
  }

  return (
    <StyledErrorContainer
      role="alert"
      aria-live="assertive"
      data-testid="error-container"
    >
      <StyledErrorMessage>{error.message}</StyledErrorMessage>
      {error.helper && (
        <StyledErrorHelperMessage>{error.helper}</StyledErrorHelperMessage>
      )}
    </StyledErrorContainer>
  );
};

export default GroupOrderErrorToast;
